import { BaseSubChain } from 'domain/entities/monomer-chains/BaseSubChain';

export class ChemSubChain extends BaseSubChain {}
